import {gql} from 'apollo-angular'
import {PROJECT_CREDIT_OUTLET_DETAILS_FRAGMENT} from "../../funds/graphql/getFunds";

export const SYNDICATIONS_CREDIT_DETAILS_FRAGMENT = gql`
  fragment SyndicationsCreditFields on ProjectCredit {
    id
    amount
    price
    equity_amount
    certificated
    taxCreditType {
      name
      level
    }
    project {
      name
      id
      properties {
        total_units
        total_lihtc_units
        entity {
          entityAddresses {
            address {
              zipCode {
                city
                state {
                  name
                  abbreviation
                }
                county {
                  name
                  metroStatAreaCounties {
                    metroStatArea {
                      name
                    }
                  }
                }
              }
            }
          }
        }
      }
      sponsor: participants(
        hasRole: { column: NAME, operator: EQ, value: "Sponsor" }
      ){
        sponsor {
          nickname
          name
          id
          __typename
        }
      }
      fundProject {
        id
        gross_equity
        ownership
      }
      projectStatuses {
        status {
          name
        }
        statusSequence{
          name
        }
        active
      }
      ltmodels(active_model: true) {
        id
        active_model
        kpiset {
          pricePerCredits{
            benefitType {
              id
              name
            }
            equity_amount
            price
          }
          kpiset_detail {
            hard_debt
            lower_tier_yield
            credit_start_date
          }
        }
        milestone {
          id
          name
        }
      }
      ownedEntity {
        id
        name
      }
      projectDetail {
        syndications_notes
      }
      taggedParticipants {
        id
        person {
          id
          name
        }
        organization {
          id
          name
        }
        sponsor {
          id
          name
        }
        role {
          name
        }
      }
      pipelineProjects(hasPipeline: { column: NAME, operator: EQ, value: "Closing" }) {
        closingDate: pipelineProjectDates(
          where: {
            AND: [
              { column: INITIAL_TARGET, value: false }
              {
                HAS: {
                  relation: "pipelineMilestone"
                  condition: {
                    AND: [
                      {
                        HAS: {
                          relation: "milestone"
                          condition: { column: "name", value: "Closed" }
                        }
                      }
                      {
                        HAS: {
                          relation: "pipeline"
                          condition: { column: "name", value: "Closing" }
                        }
                      }
                    ]
                  }
                }
              }
            ]
          }
        ){
          date
        }
      }

    }
  }
  `
export var get_project_credit_outlets = gql`
    query syndicationsCreditOutlets{
      syndicationsProjectCredits {
        projectCredit{
          ...SyndicationsCreditFields
        }
        ownership
        fundProjectState {
          name
        }
        admitted_date
        is_target
        is_target_exit
        load_percentage
        exit_date
        ut_irr
        revenue_year
        gross_equity
        estimated_gross_equity
        warehoused
        is_target_investor_approval
        investor_approval_date
        projected_warehouse_days
        fund {
          name
          id
          non_certificated_load
          certificated_load
        }
        certificatedOutlet {
          id
          non_certificated_load
          certificated_load
          organization {
            id
            name
          }
        }
      }
      fund_project_states {
        id
        name
      }
      statusesBySequence(sequence_name: "Syndications") {
        name
        id
        statusSequenceDetails {
          status_sequence_id
          index
          statusSequence{
            name
            id
          }
        }
      }
      me {
        fundPermissions: permissionsForResource(resourceType: FUND) {
          _edit
          _delete
          _create
        }
      }
    }
    ${SYNDICATIONS_CREDIT_DETAILS_FRAGMENT}
`

export var get_project_prospect_deals = gql`
    query get_projects_by_closed_sequence{
      projects(
        hasStatuses: {column: NAME, operator: EQ, value: "Prospect"},
        hasStatusSequences: {
          OR : [
            {column: NAME, operator:EQ, value: "Closing"}
            {column: NAME, operator: EQ, value: "Syndications"}
          ]
        }
      ){
        id
        name
      }
    }
`
